import script from "./PCSignPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSignPdf.vue?vue&type=script&setup=true&lang=js"

import "./PCSignPdf.vue?vue&type=style&index=0&id=4c6a0aac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6a0aac"]])

export default __exports__